import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NavbarComponent } from "./helper/navbar/navbar.component";
import { FooterComponent } from "./helper/footer/footer.component";
import { ChatbotComponent } from "./view/help/chatbot/chatbot.component";
import { CookieBannerComponent } from "./view/cookie-banner/cookie-banner.component";
import { ChatbotService } from "./service/chatbot.service";
import { FabService } from './service/fab.service';
import { KonamiService } from './service/konami.service';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { KonamiComponent } from './dialog/konami/konami.component';
import { Subscription } from 'rxjs';

import { PerformanceService } from './service/performance.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, FooterComponent, ChatbotComponent, CookieBannerComponent, MatButtonModule, MatTooltipModule, MatIconModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'jar3';
  private konamiSubscription?: Subscription;

  constructor(
    public chatbotService: ChatbotService, 
    public fabService: FabService,
    private konamiService: KonamiService,
    private dialog: MatDialog,
    private performanceService: PerformanceService
  ) {
  }

  ngOnInit(): void {
    this.performanceService.trackDuration('Load', performance.now());

    // Subscribe to Konami code triggers
    this.konamiSubscription = this.konamiService.konamiTriggered$.subscribe(triggered => {
      if (triggered) {
        this.openKonamiModal();
        this.konamiService.resetKonami();
      }
    });

  }

  ngOnDestroy(): void {
    if (this.konamiSubscription) {
      this.konamiSubscription.unsubscribe();
    }
  }

  private openKonamiModal(): void {
    this.dialog.open(KonamiComponent, {
      width: '500px',
      disableClose: false,
      autoFocus: true
    });
  }

}
